<form [formGroup]="customerForm" class="layout-form" (ngSubmit)="onSubmit()">
  <div class="component-content">
    <div class="form-header">
      <p>Nuevo Cliente</p>
      <span>Ingrese la dirección de su comercio</span>
    </div>
    <div class="scroll-display" (scroll)="onScroll($event)">
      <div class="customer-input-container">
        <app-text-input
          [attr.data-testid]="'nombre-fantansia'"
          [labelText]="'Nombre de tu Comercio'"
          [type]="'text'"
          [required]="true"
          formControlName="fantasyName"
          [submitted]="submitted"
        ></app-text-input>
      </div>
      <div [ngClass]="{ 'form-map': true, 'warning-label': submitted && !customerForm.get('location')?.valid }">
        <app-map formControlName="location" [required]="true" [submitted]="submitted"></app-map>
      </div>
    </div>
  </div>
  <div class="form-navigation">
    <app-navigation [currentStep]="1" [countSteppers]="7"></app-navigation>
  </div>
  <div class="button-container">
    <button mat-raised-button class="next-button" type="submit">Siguiente</button>
  </div>
</form>
